import React, { useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import styled from "styled-components";

const DivContainer = styled.div`
  min-height: ${(props) => props.divStyle.divMinHeight || "10vh"};
  display: block;
  flex-direction: row;
  flex-grow: 0;
`;

export const SelectList = (props) => {
  const [selectedValue, setSelectedValue] = useState("");
  const handleSelection = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <DivContainer divStyle={{}}>
      <FormControl
        sx={{ minWidth: props.selectMinWidth, maxWidth: props.selectMaxWidth }}
      >
        <InputLabel id="placeholder-label">
          {props.placeholder ? props.placeholder : "Select"}
        </InputLabel>
        <Select
          labelId="select-list-label"
          id="select-list"
          value={props.selectedValue ? props.selectedValue : selectedValue}
          label={props.selectListLabel ? props.selectListLabel : "Select"}
          onChange={props.onSelection ? props.onSelection : handleSelection}
          //renderValue={(value) => value}
          MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
        >
          {props.item &&
            props.item.length > 0 &&
            props.item.map((menuItem) => {
              return (
                <MenuItem value={menuItem.key} key={menuItem.key}>
                  {menuItem.value}
                </MenuItem>
              );
            })}
        </Select>
        {props.helperText && (
          <FormHelperText>{props.helperText}</FormHelperText>
        )}
      </FormControl>
    </DivContainer>
  );
};
